import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities'

class TournamentRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    getAllTournaments() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/tournaments`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getPublicTournaments() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/tournaments/public`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getAllTournamentParticipants(tournamentId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/tournament-participants/all?tournamentId=${tournamentId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getTournamentsByClubId(clubId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/tournaments/club?clubId=${clubId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    findParticipantByTournament(tournamentId, userId){
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/tournament-participants?tournamentId=${tournamentId}&userId=${userId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    enrollParticipant(tournamentParticipant) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/tournament-participants`, tournamentParticipant,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getTournamentOverview(tournamentId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/tournaments/overview/${tournamentId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getTournamentOverviewOpen(tournamentId,identifier) {
        let response = axios.get(`${this.basePath}/ext/tournaments/overview-open/${tournamentId}/${identifier}`);
        response = verifyAuth(response) 
        return response;
    }

    createFullTournament(fullTournament) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/tournaments/create-full`, fullTournament,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    editFullTournament(tournamentEditData) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/ext/tournaments/edit-full`, tournamentEditData,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    changeParticipantStatus(participantId, newStatus) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/ext/tournament-participants/status?participantId=${participantId}&newStatus=${newStatus}`, null,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }
}

export default new TournamentRepository();
